import classNames from './ChangeLevelPopup.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';
import {
  BulkOperationResponseData,
  BulkOperationState,
} from '@/school-management/types/services/bulk';
import Button from '@/components/school-management/Button/Button';
import Download from './Download';

interface SuccessesProps {
  students: StudentReportItem[];
  newLevelLabel: string;
  bulkOperation?: BulkOperationResponseData;
  onClose: () => void;
}

const Successes = ({ students, newLevelLabel, bulkOperation, onClose }: SuccessesProps) => {
  const { t } = useAdminTranslation();

  return (
    <>
      <div>
        <div className={classNames.title} style={{ maxWidth: '455px' }}>
          {t('bulkActions.changeLevel.successes.title', {
            count: students.length,
            newLevel: newLevelLabel,
          })}
        </div>
      </div>
      <Download
        students={students}
        newLevelLabel={newLevelLabel}
        bulkOperation={bulkOperation}
        bulkOperationState={BulkOperationState.Completed}
      />
      <div className={classNames.footer}>
        <Button className={classNames.button} onClick={onClose}>
          {t('done')}
        </Button>
      </div>
    </>
  );
};

export default Successes;
